import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';

@Component({
  selector: 'app-viewpayrolldet',
  templateUrl: './viewpayrolldet.component.html',
  styleUrls: ['./viewpayrolldet.component.css']
})
export class ViewpayrolldetComponent implements OnInit {

  //Edit Get Values
  payrollColl: any = [];
  payrollSummaryColl: any = [];
  payrollSummaryBO: any = {};
  paynettotal: any = 0;

  empBO: any = {};
  payrollBO: any = {};

  payrolllineLOP: any = {};
  islopedit: boolean = false;

  actualpayabledays: any = 0;

  payrolldetid: any = 0;

  lopdaysmanual: number = 0;


  payrollearnColl: any = [];
  payrolldeductColl: any = [];

  @Input() payrollid: any = 0;
  @Input() empid: any = null
  @Input() empname: any = null



  @Output() emitData = new EventEmitter();

  @Output() filterChanged = new EventEmitter<number>();

  @Output() payrollChanged = new EventEmitter<string>();

  companyType: string = "";
  approvedstatus: string = "";

  isformchanges: boolean = false;

  isformloading: boolean = false;

  constructor(private toastr: ToastrService, private appService: AppdataService,
    private loginService: LoginserviceService, private confirmationDialogService: ConfirmationDialogService) {

    this.fnServiceChanges();
  }


  //Company Check
  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        this.fnGetCompanyType();

      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  ngOnInit() {
    this.fnGetCompanyType();
  }

  fnGetCompanyType() {
    if (this.loginService.userBO) {
      this.companyType = this.loginService.userBO.payrolltype;
     
    }
  }

  //Get 
  fngetPayrolldetails() {
    var data = {
      'empid': this.empid,
      'payrollid': this.payrollid
    }


    this.appService.fngetPayRollByEmpid(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.isformloading = false;

            this.payrollColl = res.json().result[0];


            this.payrollSummaryColl = res.json().result[1];

            if (this.payrollSummaryColl.length > 0) {
              this.paynettotal = this.payrollSummaryColl[0].totalamount;
              this.payrollSummaryBO = this.payrollSummaryColl[0];

              this.lopdaysmanual = this.payrollSummaryBO.lopdaysmanual
            }

            this.payrollearnColl = [];


            for (let abo of this.payrollColl) {
              if (abo.earningamount > 0) {
                this.payrolldetid = abo.payrolldetid;
                this.payrollearnColl.push(abo);
              }
            }

            this.payrolldeductColl = [];

            for (let abo of this.payrollColl) {
              if (abo.deductionamount > 0) {
                this.payrolldeductColl.push(abo);
              }
            }


            //Employee
            if (res.json().result.length > 3) {
              if (res.json().result[3].length > 0) {
                this.empBO = res.json().result[3][0];
              }
            }

            //Payroll MAIN BO 
            if (res.json().result.length > 2) {
              if (res.json().result[2].length > 0) {
                this.approvedstatus = res.json().result[2][0].approvedstatus;
              
              }
            }

            

            // this.payrolllineLOP = {};
            // this.islopedit = false;

            // for (let abo of this.payrollColl) {
            //   if (abo.islop) {
            //     this.payrolllineLOP=abo;
            //   }
            // }

            this.fnCalculateLeave();

            this.isformchanges = false;
            this.isformloading= true;
          }
          else {
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }



  //Get 
  fnSaveBtnClick() {

    this.fnSetPayrollLOP();

  }

  fnInsertPayrollLOP() {

    var data = {
      'payrolldetid': this.payrolldetid,
      'islop': true,
      'unpaidleave': this.payrolllineLOP.unpaidleave,
      'modifiedby': this.loginService.fnGetModUserId(),
    }


    this.appService.fnInsertPayRollLOP(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.payrollChanged.emit('DONE')
            this.filterChanged.emit()
          }
          else {
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.toastr.error('Error', err);
        })

  }

  fnSetPayrollLOP() {

    var data = {
      'empid': this.empid,
      'payrollid': this.payrollid,
      'islop': true,
      'lopdaysmanual': this.lopdaysmanual,
      'modifiedby': this.loginService.fnGetModUserId(),
    }

    this.appService.fnSetPayRollLOP(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.payrollChanged.emit('DONE')
            this.filterChanged.emit()
          }
          else {
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.toastr.error('Error', err);
        })

  }

  fnCalculateLeave() {


    this.actualpayabledays = this.payrollSummaryBO.payabledays;

    if (this.lopdaysmanual > 0) {
      if (this.lopdaysmanual > this.payrollSummaryBO.payabledays) {
        this.lopdaysmanual = 0
      }

      this.actualpayabledays = this.actualpayabledays - Number(this.lopdaysmanual);

    }
    this.fnApplyChanges();
  }

  fnSetPayrollRemoveTransactionConfirmation(formname) { 

    // this.fnSetPayrollRemoveTransaction(formname);

    this.confirmationDialogService.confirm('Confirm..', 'Do you  want to remove '+formname+'?')
    .then((confirmed) => {
      if (confirmed) {
        this.fnSetPayrollRemoveTransaction(formname);
      }
    }
    );
  
  }
  
  fnSetPayrollRemoveTransaction(formname) {



    var data = {
      'empid': this.empid,
      'payrollid': this.payrollid,
      'formname': formname,
      'trxid':0,
      'modifiedby': this.loginService.fnGetModUserId(),
    }

    this.appService.fnSetPayrollRemoveTransaction(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
           

            if (formname === "ALL") {

              this.payrollChanged.emit('DONE')
              this.filterChanged.emit()
            } else {
              this.payrollChanged.emit('DONE')
              this.fngetPayrolldetails();
            }
          }
          else {
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.toastr.error('Error', err);
        })

  }

  fnSetPayrollRemoveConfirmation(formname) {

    this.fnSetPayrollRemoveTransaction(formname);
  }
  fnApplyChanges() {
    if (this.isformloading) {
      this.isformchanges = true; 
   }
    
  }


}
